<label [for]="controlId" style="color: black; margin-bottom: 0">{{ controlLabel }} <span class="color-red" *ngIf="required">*</span></label>
